import React from 'react'
import { Icon } from './Pin.elements'

type Props = {
  className?: string
}

export const PinIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 12 17"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M5.383 16.177C.843 9.595 0 8.92 0 6.5a6 6 0 1112 0c0 2.42-.843 3.095-5.383 9.677a.75.75 0 01-1.234 0zM6 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" fill="currentColor" />
  </Icon>
)
